import { useCallback, useMemo } from "react";
import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "../trpc.js";
import { compact } from "es-toolkit";
import { getChatSubscriptionStore } from "../stores/chatSubscriptionStore.js";
import { useAppAction } from "./redux.js";
import { useStyleEditor } from "../components/StyleEditorContext.js";
import { changeChatId } from "../reducers/chatReducer.js";
function getChatHistory(chat) {
    if (!chat)
        return [];
    return compact(chat.messages
        .map((message) => {
        if (message.role === "assistant" && message.spec) {
            const text = message.content.find(b => b.type === "text");
            return {
                messageId: message.id,
                text: text?.text.slice(0, 30) ?? "Assistant change",
                spec: message.spec,
            };
        }
        return;
    }));
}
export function useChatChangeStore(styleId) {
    const trpc = useTRPC();
    const changeChat = useAppAction(changeChatId);
    const { onChatChange } = useStyleEditor();
    const store = getChatSubscriptionStore(styleId);
    const { mutateAsync: createNewChat } = useMutation(trpc.createNewChat.mutationOptions());
    const handleChangeChat = useCallback((id) => {
        const chat = store.getChat(id);
        changeChat({
            id,
            history: getChatHistory(chat),
        });
        onChatChange?.(id);
    }, [store, changeChat, onChatChange]);
    const handleNewChat = useCallback(async (chatData) => {
        return createNewChat({ styleId })
            .then((chat) => {
            const newChat = Object.assign(chat, chatData);
            store.addSemiOptimisticChat(newChat);
            handleChangeChat(newChat.id);
            return newChat;
        });
    }, [styleId, createNewChat, handleChangeChat]);
    return useMemo(() => ({
        changeChat: handleChangeChat,
        newChat: handleNewChat,
    }), [handleChangeChat, handleNewChat]);
}
